import { render, staticRenderFns } from "./confirmUserData.vue?vue&type=template&id=56047a9b&scoped=true&"
import script from "./confirmUserData.vue?vue&type=script&lang=js&"
export * from "./confirmUserData.vue?vue&type=script&lang=js&"
import style0 from "./confirmUserData.vue?vue&type=style&index=0&id=56047a9b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56047a9b",
  null
  
)

export default component.exports